export const calculateFontXHeight = (font) => {
    if (font.hasGlyphForCodePoint(120)) {
        const glyph = font.glyphForCodePoint(120);
        const bbox = glyph.getBoundingBox();
        return (bbox.y2 - bbox.y1) / font.unitsPerEm;
    }
    return font.tables.os2.sxHeight / font.unitsPerEm;
};
